export default {
  data () {
    return {
      orgId:"",
      okBaoJumpMap:{
        '-1':"/apps/signRegister",
        '0':"/apps/ok-sign/ok-register",//信息登记
        '1':"/apps/ok-sign/ok-face",//人脸
        '2':"/apps/ok-sign/ok-train",//入职培训
        '3':"",//待阅读协议 暂无用
        '4':"/apps/ok-sign/ok-contract",//合同
        '5':"/apps/ok-sign/result",//结果页
      },
      jumpMap:{
        '-1':"/apps/signRegister",
        '0':"/apps/sign/register",
        '1':"/apps/sign/face",
        '2':"/apps/sign/train",
        '3':"",//待阅读协议 暂无用
        '4':"/apps/sign/contract",
        '5':"/apps/sign/success",
        '6':"/apps/sign/end",
      }
    };
  },
  mounted() {
    this.orgId = this.$route.query.orgId;
  },
  methods: {
    setUserinfoAjax(){
      this.$http({
        url: "/app/visitor/uploadVisitorRecord",
        type: "PUT",
        hideAlert: true,
        data: {
          typeId:'0',
          type: 10,
          mechanId: this.$route.query.userId,
          nickName: this.userInfo.nickName || "微信访客",
          imgUrl: this.userInfo.icon,
          openId: this.userInfo.openid
        }
      }).then(res=>{
        this.startVisitorTimer(res.data.id);
      });
    },
    checkLogin(noCheck,noCheckStatus){
      return new Promise((resolved, rejected) => {
        if(noCheck){
          resolved()
          return
        }
        if(!localStorage.regToken) {
          const url = "/apps/signRegister"
          if(url == this.$route.path){
            resolved();
            return
          }
          this.$router.replace({
            path: "/apps/signRegister",
            query: this.$route.query
          });
          rejected();
          return;
        }
        if(noCheckStatus){
          resolved()
          return
        }
        this.$http({
          type: "POST",
          url: "/api/userAuth/queryregistStatus",
          hideAlert:true,
          data: {
            token: localStorage.regToken,
            orgId: this.orgId,
          },
        }).then((res) => {
          if(res.httpCode != 1 || res.data.isClearToken == 1) {
            if(res.data.isClearToken == 1) {
              localStorage.regToken = '';
              localStorage['regToken' + sessionStorage.orgId] = '';
            }
            const url = "/apps/signRegister"
            if(url == this.$route.path){
              resolved();
              return
            }
            this.$router.replace({
              path: "/apps/signRegister",
              query: this.$route.query
            });
            rejected();
            return
          }
          const data = res.data;
          const merchantNo = data.merchantNo;
          let url = this.jumpMap[data.status];
          if(this.$tools.isOKbao(merchantNo) || this.$tools.isRYBB(merchantNo)) {
            url = this.okBaoJumpMap[data.status];
          }
          if(this.$tools.isOKTX(merchantNo) && data.status == 0) {
            url = '/apps/sign/ok-register';
          }
          if(this.$route.query.noCheckStatus == 1){
            resolved(res);
            return
          }
          if(url != this.$route.path){
            this.$router.replace({
              path: url,
              query: this.$route.query
            });
            rejected();
          }else{
            resolved(res)
          }
        })
      })
      
    },
    jumpOKBAO(status){
      const url = this.okBaoJumpMap[status];
      if(url != this.$route.path){
        window.setTimeout(()=>{
          this.$router.replace({
            path: url,
            query: this.$route.query
          });
        }, 300);
      }
    },
    jump(status) {
      const url = this.jumpMap[status];
      if(url != this.$route.path){
        window.setTimeout(()=>{
          this.$router.replace({
            path: url,
            query: this.$route.query
          });
        }, 300);
      }
    }
  }
}